import { API_V2 } from "@Models/GWDomain";

export const baseUrl = `${API_V2}/employees`;
export const accountBaseUrl = `${API_V2}/account`;

/** US2 spec 016 — preview del impacto de un cambio de horario (no persiste). */
export const SCHEDULE_IMPACT_API = (id: number) =>
  `${baseUrl}/${id}/schedule-impact`;

/** US2 spec 016 — PUT que persiste el horario (puede reasignar afectados). */
export const SCHEDULES_API = `${baseUrl}/schedules`;

const tokenLocal = localStorage.getItem("access_token");

export const config = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenLocal}`,
  },
};
